(function ($) {
    $(document).ready(function () {

        const showDonationSuccessPopup = () => {
            const params = new URLSearchParams(window.location.search);
            const donationStatus = params.get('donation_status');

            if (donationStatus !== 'success') {
                return;
            }

            const $popup = $('#donation-success-popup');

            if (!$popup.length) {
                return;
            }

            $popup.modal('show');

            const cleanUrl = window.location.origin + window.location.pathname;

            window.history.replaceState({}, document.title, cleanUrl);
        };

        showDonationSuccessPopup();

        $('.js-donation-status-close').on('click', function () {
            $('#donation-status-popup').modal('hide');
        });

        // Modal copy button
        $('.popup-make-a-donation .popup-description ul li').on('click', function () {
            let wrapText = $(this).find('.wrap-text');
            if (wrapText.hasClass('not-copy')) return;

            let $input = $(this).find('.input');
            let $copyMessage = $('.success-copy-message');
            let text = $input.text().trim();
            let position = $input.position().top - 23;

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(() => {
                    $copyMessage.css('top', position + 'px').fadeIn().delay(600).fadeOut();
                }).catch(err => {
                    console.error('Clipboard API error:', err);
                });
            } else {
                let $temp = $('<textarea>');
                $('body').append($temp);
                $temp.val(text).select();
                document.execCommand('copy');
                $temp.remove();

                $copyMessage.css('top', position + 'px').fadeIn().delay(600).fadeOut();
            }
        });

        const updateAmountCurrencyLabels = ($form, currency) => {
            $form.find('.js-card-amount-tabs [data-amount] span').text(currency);
        };

        $('#card-currency-tabs a[data-currency]').on('click', function (e) {
            e.preventDefault();

            const $link = $(this);
            const $form = $link.closest('.js-donation-card-form');
            const currency = $link.data('currency');

            $link
                .closest('li')
                .addClass('active')
                .siblings()
                .removeClass('active');

            $form.find('input[name="currency"]').val(currency);

            updateAmountCurrencyLabels($form, currency);
        });

        $('#card-amount-tabs a').on('click', function (e) {
            e.preventDefault();

            const $link = $(this);
            const $form = $link.closest('.js-donation-card-form');
            const $amountInput = $form.find('.js-donation-custom-amount');

            $link
                .closest('li')
                .addClass('active')
                .siblings()
                .removeClass('active');

            if ($link.data('custom')) {
                $amountInput.val('').focus();
                return;
            }

            $amountInput.val($link.data('amount'));
        });

        $('.js-donation-custom-amount').on('input', function () {
            const $form = $(this).closest('.js-donation-card-form');

            $form.find('#card-amount-tabs li').removeClass('active');
            $form.find('#card-amount-tabs .js-custom-amount-trigger').closest('li').addClass('active');
        });

        $('.js-donation-card-form').on('submit', function (e) {
            e.preventDefault();

            const $form = $(this);
            const $button = $form.find('.js-donation-submit');
            const $error = $form.find('.js-donation-error');

            const amount = parseFloat($form.find('input[name="amount"]').val());
            const currency = $form.find('input[name="currency"]').val();

            $error.hide().text('');

            if (!amount || amount <= 0) {
                $error.text('Вкажіть суму внеску.').fadeIn();
                return;
            }

            if (!currency) {
                $error.text('Оберіть валюту.').fadeIn();
                return;
            }

            $button.prop('disabled', true).addClass('is-loading');

            $.ajax({
                url: MyAjax.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'create_liqpay_donation',
                    nonce: MyAjax.donation_nonce,
                    amount: amount,
                    currency: currency,
                    first_name: $form.find('input[name="first_name"]').val(),
                    last_name: $form.find('input[name="last_name"]').val(),
                    email: $form.find('input[name="email"]').val(),
                    phone: $form.find('input[name="phone"]').val()
                },
                success: function (response) {
                    if (!response.success || !response.data) {
                        const message = response.data && response.data.message
                            ? response.data.message
                            : 'Не вдалося створити платіж.';

                        $error.text(message).fadeIn();
                        return;
                    }

                    const $liqpayForm = $('<form>', {
                        method: 'POST',
                        action: response.data.action,
                        acceptCharset: 'utf-8'
                    });

                    $liqpayForm.append($('<input>', {
                        type: 'hidden',
                        name: 'data',
                        value: response.data.data
                    }));

                    $liqpayForm.append($('<input>', {
                        type: 'hidden',
                        name: 'signature',
                        value: response.data.signature
                    }));

                    $('body').append($liqpayForm);
                    $liqpayForm.trigger('submit');
                },
                error: function () {
                    $error.text('Сталася помилка. Спробуйте ще раз.').fadeIn();
                },
                complete: function () {
                    $button.prop('disabled', false).removeClass('is-loading');
                }
            });
        });

        const showDonationStatusPopup = (status) => {
            const $popup = $('#donation-status-popup');
            const $title = $popup.find('.js-donation-status-title');

            if (!$popup.length) {
                return;
            }

            if (status === 'success') {
                $title.text('Щиро дякуємо за ваш внесок!');
                $popup.removeClass('is-failure').addClass('is-success');
            } else {
                $title.text('Платіж не вдалося провести');
                $popup.removeClass('is-success').addClass('is-failure');
            }

            const cleanUrl = window.location.origin + window.location.pathname;

            window.history.replaceState({}, document.title, cleanUrl);

            $popup.modal('show');
        };

        const handleDonationOrderReturn = () => {
            const params = new URLSearchParams(window.location.search);
            const orderId = params.get('order_id');

            if (!orderId) {
                return;
            }

            let pendingAttempts = 0;
            const maxPendingAttempts = 3;

            const checkOrderStatus = () => {
                $.ajax({
                    url: MyAjax.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'get_liqpay_donation_status',
                        order_id: orderId
                    },
                    success: function (response) {
                        if (!response.success || !response.data) {
                            showDonationStatusPopup('failure');
                            return;
                        }

                        const status = response.data.status;

                        if (status === 'success') {
                            showDonationStatusPopup('success');
                            return;
                        }

                        if (status === 'failure' || status === 'not_found') {
                            showDonationStatusPopup('failure');
                            return;
                        }

                        if (status === 'pending') {
                            pendingAttempts++;

                            if (pendingAttempts >= maxPendingAttempts) {
                                showDonationStatusPopup('failure');
                                return;
                            }

                            setTimeout(checkOrderStatus, 1000);
                            return;
                        }

                        showDonationStatusPopup('failure');
                    },
                    error: function () {
                        showDonationStatusPopup('failure');
                    }
                });
            };

            checkOrderStatus();
        };

        handleDonationOrderReturn();

    });

})(jQuery);